import { Box, Chip, Stack } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid'

const TableLanguagesCell = ({ params }: { params: GridCellParams }) => {
  let languages = params.row.languages || params.row.language_codes || params.row.languageCode || []
  if (typeof languages === 'string') {
    languages = languages.split(',').map((code: string) => ({ code: code.trim() }))
  } else if (!Array.isArray(languages)) {
    languages = [languages]
  }

  const pairs = []
  for (let i = 0; i < languages.length; i += 2) {
    pairs.push(languages.slice(i, i + 2))
  }

  return (
    <Stack spacing={1}>
      {pairs.map((pair, index) => (
        <Box key={index} sx={{ display: 'flex', gap: 1 }}>
          {pair.map((lang: any) => (
            <Chip key={lang.code ? lang.code : index} label={(lang.code || '').toUpperCase()} size="small" sx={{ maxWidth: '100%' }} />
          ))}
        </Box>
      ))}
    </Stack>
  )
}

export default TableLanguagesCell
